const CreateNewEventEmptyGridBox = ({i, createNewEventByClickBlankSpace}) => {
    return (
        Array.from(Array(7), (e, col) => (
            <div key={col} className={`col-start-${col} opacity-50`} onClick={() => createNewEventByClickBlankSpace(col, i)} style={{ gridRow: `${i + 1}/ ${i + 2}`}}></div>
        ))
    )
}
export default CreateNewEventEmptyGridBox
